export default __webpack_public_path__ + "static/media/christmas.e71b3240.jpg";